module.exports = __webpack_public_path__ + "media/9ea2a5d59aee4b9a97dc430c0a1ee575.6fb86614.mp4";